import { lazy, Suspense, useSyncExternalStore } from 'react';
import { importAnnounced, subscribeImportAnnounced } from './notionImportSignal';

const Panel = lazy(async () => ({ default: (await import('./NotionImportPanel')).NotionImportPanel }));

/** Место плашки импорта в корне приложения: код плашки подгружается, только когда импорт начался. */
export function NotionImportHost() {
  const on = useSyncExternalStore(subscribeImportAnnounced, importAnnounced);
  if (!on) return null;
  return (
    <Suspense fallback={null}>
      <Panel />
    </Suspense>
  );
}
